import React from 'react';
import RoleBasedRoute from './RoleBasedRoute';

/**
 * Protected route specifically for influencer users
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if authenticated
 * @returns {React.ReactNode} - The protected component or redirect
 */
const InfluencerRoute = ({ children }) => {
  return (
    <RoleBasedRoute 
      allowedRoles="Influencer" 
      redirectPath="/login"
    >
      {children}
    </RoleBasedRoute>
  );
};

export default InfluencerRoute;
